import React, { useEffect, useState } from 'react'
import BackButton from 'components/BackButton'
import NomeTerreno from 'components/NomeTerreno'
import { Accordion, AccordionDetails, AccordionSummary, Button, Checkbox, FormControlLabel } from '@material-ui/core'
import * as S from './index.style'
import { TrendingUp } from '@styled-icons/material-rounded/TrendingUp'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { DadosGerais, dadosGeraisValorDefault } from 'models/Viabilidade/DadosGerais'
import { DadosLoteadora, dadosLoteadoraValorDefault } from 'models/Viabilidade/Loteadora'
import { DadosCompraTerreno, dadosCompraTerrenoValorDefault } from 'models/Viabilidade/DadosCompraTerreno'
import { DadosUrbanizacao, dadosUrbanizacaoValorDefault } from 'models/Viabilidade/Urbanizacao'
import { DadosInfraestrutura, dadosInfraestruturaValorDefault } from 'models/Viabilidade/Infraestrutura'
import { DadosComercial, dadosComercialValorDefault } from 'models/Viabilidade/Comercial'
import CartaoDadosGerais from 'components/Viabilidades/NovaViabilidade/CartaoDadosGerais'
import CardLoteadora from 'components/Viabilidades/NovaViabilidade/CardLoteadora'
import CartaoDadosCompraTerreno from 'components/Viabilidades/NovaViabilidade/CartaoDadosCompraTerreno'
import CardInfraestrutura from 'components/Viabilidades/NovaViabilidade/CardInfraestrutura'
import CardConstrucao from 'components/Viabilidades/NovaViabilidade/CardConstrucao'
import CardUrbanizacao from 'components/Viabilidades/NovaViabilidade/CardUrbanizacao'
import { buscarMoedaMrvPorData, buscarMoedaMrvVigente } from 'services/parametros.service'
import { MoedaMrv } from 'models/Parametro/MoedaMrv'
import { NomesCartoesViabilidadeEnum } from 'models/Viabilidade/Enum/NomesCartoesViabilidadeEnum'
import { TipoProjetoEnum } from 'models/Viabilidade/Enum/TipoProjetoEnum'
import { DadosConstrucao, dadosConstrucaoValorDefault } from 'models/Viabilidade/Construcao'
import CardComercial from 'components/Viabilidades/NovaViabilidade/CardComercial'
import { DadosDetalhamentoProjeto, dadosDetalhamentoProjetoValorDefault } from 'models/Viabilidade/DadosDetalhamentoProjeto'
import CartaoDadosDetalhamentoProjeto from 'components/Viabilidades/NovaViabilidade/CartaoDetalhamentoProjeto'
import { adicionarCasas, modificarCasas, buscarViabilidadePorId } from 'services/viabilidadeCasas.service'
import { CasasEntrada, mapearCasasEntrada } from 'models/Viabilidade/CasasEntrada'
import { IViabilidadeRoutParams } from 'pages/Viabilidade'
import { CasasSaida } from 'models/Viabilidade/CasasSaida'
import MensagensErro, { MensagemErro } from 'components/MensagensErro'
import { processandoDados } from 'helpers/Constantes/Mensagens'
import Progress from 'components/Progress'
import ModalProgress from 'components/ModalProgress'
import { Guid } from 'guid-typescript'
import { DadosGarantias } from 'models/Viabilidade/Garantias'
import Erro from 'components/Erro'
import { TipoSituacaoEnum } from 'models/Viabilidade/Enum/TipoSituacaoEnum'
import { ModeloNegocioEnum } from 'models/Viabilidade/Enum/ModeloNegocioEnum'

export interface IStateLocation {
  nomeTerreno: string
  areaTerreno: number
  dataCompraTerreno?: string
  token: string
  idViabilidade?: Guid
  situacaoViabilidade?: TipoSituacaoEnum
  nomeViabilidadeClonada?: string
  fase: number
  idEmpreendimento?: Guid
}

const CARDS_INICIAM_ABERTOS = true
const TOTAL_CARDS = 8

const ERROS_VALIDACAO: MensagemErro[] = []
const EXIBIR_MODAL_PROGRESS = false

export const NovaViabilidade: React.FC = () => {
  const history = useHistory()
  const { state } = useLocation<IStateLocation>()
  const { idTerreno } = useParams<IViabilidadeRoutParams>()
  const icon = <S.IconeExpandir />

  const [encolherTudo, setEncolherTudo] = useState(!CARDS_INICIAM_ABERTOS)
  const [cards, setCards] = useState(new Array(TOTAL_CARDS).fill(CARDS_INICIAM_ABERTOS))
  const [errosValidacao, setErrosValidacao] = useState(ERROS_VALIDACAO)
  const [exibirModalProgress, setExibirModalProgress] = useState(EXIBIR_MODAL_PROGRESS)

  const [informacoesDadosGerais, setInformacoesDadosGerais] = useState(dadosGeraisValorDefault)
  const [informacoesDadosLoteadora, setInformacoesDadosLoteadora] = useState(dadosLoteadoraValorDefault)
  const [informacoesDadosInfraestrutura, setInformacoesDadosInfraestrutura] = useState(dadosInfraestruturaValorDefault)
  const [informacoesDadosConstrucao, setInformacoesDadosConstrucao] = useState(dadosConstrucaoValorDefault)
  const [informacoesDadosUrbanizacao, setInformacoesDadosUrbanizacao] = useState(dadosUrbanizacaoValorDefault)
  const [informacoesDadosCompraTerreno, setInformacoesDadosCompraTerreno] = useState(dadosCompraTerrenoValorDefault)
  const [informacoesDadosDetalhamentoProjeto, setInformacoesDadosDetalhamentoProjeto] = useState(dadosDetalhamentoProjetoValorDefault)
  const [informacoesDadosComercial, setInformacoesDadosComercial] = useState(dadosComercialValorDefault)
  const [carregouMoedaVigente, setCarregouMoedaVigente] = useState(false)
  const [carregouMoedaCompra, setCarregouMoedaCompra] = useState(false)
  const [carregouRascunho, setCarregouRascunho] = useState(false)

  const [ocorreuErro, setOcorreuErro] = useState(false)

  useEffect(() => {
    const buscarViabilidade = async (idViabilidade: Guid) => {
      await buscarViabilidadePorId(idViabilidade)
        .then((respostaApi) => {
          const casasSaida = respostaApi.entity
          casasSaida.dadosGerais.valido = true
          if (state.nomeViabilidadeClonada) {
            casasSaida.dadosGerais.nomeViabilidade = state.nomeViabilidadeClonada
          }
          dadosGeraisHandler(casasSaida.dadosGerais)

          const loteadora = {
            precoLote: casasSaida.loteadora.precoLote,
            valido: true
          } as DadosLoteadora
          dadosLoteadoraHandler(loteadora)

          const garantias = {
            FiancaBancariaTerreno: casasSaida.dadosCompraTerreno.garantias.fiancaBancariaTerreno > 0,
            SeguroGarantiaUrbanizacao: casasSaida.dadosCompraTerreno.garantias.seguroGarantiaUrbanizacao > 0,
            SeguroGarantiaPermutaFisica: casasSaida.dadosCompraTerreno.garantias.seguroGarantiaPermutaFisica > 0
          } as DadosGarantias
          casasSaida.dadosCompraTerreno.datas.valido = true
          casasSaida.formaPagamento.permuta.valido = true
          casasSaida.dadosCompraTerreno.despesasAcessorias.valido = true
          const compraTerreno = {
            datas: casasSaida.dadosCompraTerreno.datas,
            permuta: casasSaida.formaPagamento.permuta,
            torna: casasSaida.dadosCompraTerreno.torna,
            garantias: garantias,
            despesasAcessorias: casasSaida.dadosCompraTerreno.despesasAcessorias,
            id: casasSaida.dadosCompraTerreno.id
          } as DadosCompraTerreno

          dadosCompraTerrenoHandler(compraTerreno)

          casasSaida.detalhamentoProjeto.loteamentoComercial.valido = true
          casasSaida.detalhamentoProjeto.muros.valido = true
          const detalhamentoProjeto = {
            tipologias: casasSaida.detalhamentoProjeto.tipologias,
            loteamentoComercial: casasSaida.detalhamentoProjeto.loteamentoComercial,
            componentesProjeto: casasSaida.detalhamentoProjeto.componentesProjeto,
            muros: casasSaida.detalhamentoProjeto.muros,
            id: casasSaida.detalhamentoProjeto.id
          } as DadosDetalhamentoProjeto
          dadosDetalhamentoProjetoHandler(detalhamentoProjeto)

          const comercial = {
            descontoItbiRegistro: casasSaida.comercial.valorDescontoItbiRegistro > 0,
            descontoBomPagador: casasSaida.comercial.descontoBomPagador,
            parcelamento: casasSaida.comercial.parcelamento,
            valido: true
          } as DadosComercial
          dadosComercialHandler(comercial)

          casasSaida.construcao.valido = true
          dadosConstrucaoHandler(casasSaida.construcao)

          casasSaida.urbanizacao.valido = true
          dadosUrbanizacaoHandler(casasSaida.urbanizacao)

          casasSaida.infraestrutura.valido = true
          dadosInfraestruturaHandler(casasSaida.infraestrutura)

          setCarregouRascunho(true)
        })
        .catch(() => {
          setOcorreuErro(true)
        })
    }
    if (state.idViabilidade && state.situacaoViabilidade && state.situacaoViabilidade === TipoSituacaoEnum.Rascunho) {
      buscarViabilidade(state.idViabilidade)
    } else {
      setCarregouRascunho(true)
    }
  }, [state.idViabilidade, state.nomeViabilidadeClonada, state.situacaoViabilidade])

  useEffect(() => {
    setEncolherTudo(cards.every((item) => !item))
  }, [cards])

  const buscarMoedaVigente = async (stateDadosGerais: DadosGerais) => {
    await buscarMoedaMrvVigente()
      .then((respostaApi: { isSuccess: boolean; entity: unknown }) => {
        stateDadosGerais.valorMoedaMrvAtual = (respostaApi.entity as MoedaMrv).valorMoedaAtual.toString()
        stateDadosGerais.valorMoedaMrvCompra = stateDadosGerais.valorMoedaMrvCompra ? stateDadosGerais.valorMoedaMrvCompra : stateDadosGerais.valorMoedaMrvAtual
        setCarregouMoedaVigente(true)
      })
      .catch(() => {
        setOcorreuErro(true)
      })
  }

  const buscarMoedaPorData = async (stateDadosGerais: DadosGerais, data: string) => {
    await buscarMoedaMrvPorData(data)
      .then((respostaApi: { isSuccess: boolean; entity: unknown }) => {
        stateDadosGerais.valorMoedaMrvCompra = (respostaApi.entity as MoedaMrv).valorMoedaAtual.toString()
        setCarregouMoedaCompra(true)
      })
      .catch(() => {
        setOcorreuErro(true)
      })
  }

  useEffect(() => {
    const stateDadosGerais = dadosGeraisValorDefault

    stateDadosGerais.areaTerrenoBruta = stateDadosGerais.areaTerrenoLiquida = state.areaTerreno ? state.areaTerreno.toString() : ''

    buscarMoedaVigente(stateDadosGerais)

    if (state.dataCompraTerreno) {
      const data = new Intl.DateTimeFormat('pt-BR').format(new Date(state.dataCompraTerreno))
      buscarMoedaPorData(stateDadosGerais, data)
    } else {
      setCarregouMoedaCompra(true)
    }

    setInformacoesDadosGerais(stateDadosGerais)
  }, [state.dataCompraTerreno, state.areaTerreno])

  const toggleEncolherTudo = (event: React.ChangeEvent<HTMLInputElement>) => {
    const encolher = !event.target.checked
    const novoCards = cards.map(() => encolher)
    setCards(novoCards)
  }

  const toggleCard = (index: number) => {
    const novoCards = [...cards]
    novoCards[index] = !novoCards[index]
    setCards(novoCards)
  }

  const dadosGeraisHandler = (novoValor: DadosGerais): void => {
    setInformacoesDadosGerais(novoValor)
  }

  const dadosCompraTerrenoHandler = (novoValor: DadosCompraTerreno): void => {
    setInformacoesDadosCompraTerreno(novoValor)
  }

  const dadosUrbanizacaoHandler = (novoValor: DadosUrbanizacao): void => {
    setInformacoesDadosUrbanizacao(novoValor)
  }

  const dadosLoteadoraHandler = (novoValor: DadosLoteadora): void => {
    setInformacoesDadosLoteadora(novoValor)
  }

  const dadosInfraestruturaHandler = (novoValor: DadosInfraestrutura): void => {
    setInformacoesDadosInfraestrutura(novoValor)
  }

  const dadosConstrucaoHandler = (novoValor: DadosConstrucao): void => {
    setInformacoesDadosConstrucao(novoValor)
  }

  const dadosComercialHandler = (novoValor: DadosComercial): void => {
    setInformacoesDadosComercial(novoValor)
  }

  const dadosDetalhamentoProjetoHandler = (novoValor: DadosDetalhamentoProjeto): void => {
    setInformacoesDadosDetalhamentoProjeto(novoValor)
  }

  const validaBotaoSimularHabilitado = (): boolean => {
    if (
      informacoesDadosGerais.valido &&
      informacoesDadosCompraTerreno.datas.valido &&
      informacoesDadosDetalhamentoProjeto.muros.valido &&
      informacoesDadosDetalhamentoProjeto.loteamentoComercial.valido &&
      informacoesDadosConstrucao.valido &&
      informacoesDadosUrbanizacao.valido &&
      informacoesDadosComercial.valido
    ) {
      if (informacoesDadosGerais.tipoProjeto === TipoProjetoEnum.LoteamentoAberto && informacoesDadosLoteadora.valido) {
        if (informacoesDadosGerais.modeloNegocio != ModeloNegocioEnum.MrvAdquirenteLote) return false

        if (
          informacoesDadosGerais.modeloNegocio === ModeloNegocioEnum.MrvAdquirenteLote &&
          informacoesDadosInfraestrutura.valido &&
          informacoesDadosCompraTerreno.despesasAcessorias.valido &&
          informacoesDadosCompraTerreno.permuta.valido
        ) {
          return false
        }

        return true
      }

      if (
        informacoesDadosGerais.tipoProjeto === TipoProjetoEnum.CondominioIncorporacao &&
        informacoesDadosInfraestrutura.valido &&
        informacoesDadosCompraTerreno.despesasAcessorias.valido &&
        informacoesDadosCompraTerreno.permuta.valido
      ) {
        return false
      }
      return true
    }
    return true
  }

  const goToResultadoViabilidade = (casasSaida: CasasSaida) => {
    history.push(casasSaida.id, {
      idViabilidade: casasSaida.id,
      nomeTerreno: state.nomeTerreno,
      token: state.token,
      resultadoViabilidade: casasSaida,
      situacao: state.situacaoViabilidade,
      areaTerreno: state.areaTerreno,
      dataCompraTerreno: state.dataCompraTerreno,
      fase: state.fase,
      idEmpreendimento: state.idEmpreendimento
    })
  }

  const dadosEntrada = mapearCasasEntrada(
    idTerreno,
    informacoesDadosGerais,
    informacoesDadosCompraTerreno,
    informacoesDadosDetalhamentoProjeto,
    informacoesDadosInfraestrutura,
    informacoesDadosLoteadora,
    informacoesDadosComercial,
    informacoesDadosConstrucao,
    informacoesDadosUrbanizacao,
    state.fase,
    state.situacaoViabilidade,
    state.idViabilidade,
    state.idEmpreendimento
  )

  const validarFormaPagamento = (entrada: CasasEntrada, listaErros: MensagemErro[]) => {
    if (
      entrada.dadosCompraTerreno.permuta.permutaNoLocalFiscalCasas == '' &&
      entrada.dadosCompraTerreno.permuta.permutaNoLocalFiscalLotes == '' &&
      entrada.dadosCompraTerreno.permuta.permutaForaDoLocalFiscal == '' &&
      entrada.dadosCompraTerreno.permuta.porcetagemVgvPermutaFinanceiraBruta == '' &&
      entrada.dadosCompraTerreno.permuta.porcentagemDescontoPermutaFinanceira == '' &&
      entrada.dadosCompraTerreno.permuta.valorEscrituradoTerreno == '' &&
      entrada.dadosCompraTerreno.torna.length == 0
    ) {
      listaErros.push({
        titulo: 'DADOS DE COMPRA DO TERRENO',
        mensagens: ['É preciso inserir um tipo de forma de pagamento.']
      })
    }
  }

  const validarUnidadesPermutaTipologias = (entrada: CasasEntrada, listaErros: MensagemErro[]) => {
    if (
      (entrada.dadosCompraTerreno.permuta.permutaNoLocalFiscalCasas || entrada.dadosCompraTerreno.permuta.permutaNoLocalFiscalLotes) &&
      entrada.detalhamentoProjeto.tipologias.filter((f) => f.quantidadePermutas).length == 0
    ) {
      listaErros.push({
        titulo: 'DETALHAMENTO DE PROJETO > Tipologias',
        mensagens: ['É preciso ter unidades em permuta.']
      })
    }
  }

  const validarValorPermutaLocalFiscalCasas = (entrada: CasasEntrada, listaErros: MensagemErro[]) => {
    if (
      entrada.detalhamentoProjeto.tipologias.filter((f) => f.quantidadePermutas).length != 0 &&
      entrada.dadosCompraTerreno.permuta.permutaNoLocalFiscalCasas == ''
    ) {
      listaErros.push({
        titulo: 'DADOS COMPRA TERRENO > Permuta',
        mensagens: ['É preciso preencher o campo "Valor Permutas No Local Valor Fiscal - Casas (R$)".']
      })
    }
  }

  const validarUnidadesPermutaLoteamentoComercial = (entrada: CasasEntrada, listaErros: MensagemErro[]) => {
    if (entrada.dadosCompraTerreno.permuta.permutaNoLocalFiscalLotes && entrada.detalhamentoProjeto.loteamentoComercial.quantidadePermutas == '') {
      listaErros.push({
        titulo: 'DETALHAMENTO DE PROJETO > Loteamento Comercial',
        mensagens: ['É preciso ter unidades em permuta.']
      })
    }
  }

  const validarValorPermutaLocalFiscalLotes = (entrada: CasasEntrada, listaErros: MensagemErro[]) => {
    if (entrada.detalhamentoProjeto.loteamentoComercial.quantidadePermutas != '' && entrada.dadosCompraTerreno.permuta.permutaNoLocalFiscalLotes == '') {
      listaErros.push({
        titulo: 'DADOS COMPRA TERRENO > Permuta',
        mensagens: ['É preciso preencher o campo "Valor Permutas No Local Valor Fiscal - Lotes (R$)".']
      })
    }
  }

  const validarLimiteMinimoUrbanizacao = (entrada: CasasEntrada, listaErros: MensagemErro[]) => {
    if (entrada.urbanizacao.itensUrbanizacao.length == 0) {
      listaErros.push({
        titulo: 'URBANIZAÇÃO',
        mensagens: ['É necessário adicionar uma urbanização.']
      })
    }
  }

  const validarTipologias = (entrada: CasasEntrada, listaErros: MensagemErro[]) => {
    if (entrada.detalhamentoProjeto.tipologias.length == 0) {
      listaErros.push({
        titulo: 'DETALHAMENTO DO PROJETO > Tipologias',
        mensagens: ['É necessário adicionar uma tipologia.']
      })
    } else if (entrada.detalhamentoProjeto.tipologias.length > 10) {
      listaErros.push({
        titulo: 'DETALHAMENTO DO PROJETO > Tipologias',
        mensagens: ['É necessário que tenha no máximo 10 tipologias.']
      })
    }
  }

  const validarTorna = (entrada: CasasEntrada, listaErros: MensagemErro[]) => {
    if (entrada.dadosCompraTerreno.torna.length > 10) {
      listaErros.push({
        titulo: 'DADOS DE COMPRA DO TERRENO > Torna',
        mensagens: ['É necessário que tenha no máximo 10 parcelas.']
      })
    }
  }

  const validarLimiteMaximoUrbanizacao = (entrada: CasasEntrada, listaErros: MensagemErro[]) => {
    if (entrada.urbanizacao.itensUrbanizacao.length > 6) {
      listaErros.push({
        titulo: 'URBANIZAÇÃO',
        mensagens: ['É necessário que tenha no máximo 6 itens de urbanização.']
      })
    }
  }

  const validarComposicaoViabilidade = (entrada: CasasEntrada): boolean => {
    const listaErros: MensagemErro[] = []

    if (entrada.dadosGerais.tipoProjeto == TipoProjetoEnum.CondominioIncorporacao || entrada.dadosGerais.modeloNegocio == ModeloNegocioEnum.MrvAdquirenteLote) {
      validarFormaPagamento(entrada, listaErros)
      validarUnidadesPermutaTipologias(entrada, listaErros)
      validarValorPermutaLocalFiscalCasas(entrada, listaErros)
      validarUnidadesPermutaLoteamentoComercial(entrada, listaErros)
      validarValorPermutaLocalFiscalLotes(entrada, listaErros)
      validarTorna(entrada, listaErros)
    }

    if (entrada.dadosGerais.tipoProjeto == TipoProjetoEnum.CondominioIncorporacao) validarLimiteMinimoUrbanizacao(entrada, listaErros)

    validarTipologias(entrada, listaErros)
    validarLimiteMaximoUrbanizacao(entrada, listaErros)

    setErrosValidacao(listaErros)
    if (listaErros.length != 0) {
      window.scrollTo(0, 0)
    }
    return listaErros.length == 0
  }

  const simular = async (entrada: CasasEntrada) => {
    if (validarComposicaoViabilidade(entrada)) {
      setExibirModalProgress(true)

      if (!state.situacaoViabilidade) {
        await adicionarCasas(entrada)
          .then((respostaApi: { isSuccess: boolean; entity: unknown }) => {
            const resposta = respostaApi.entity as CasasSaida
            goToResultadoViabilidade(resposta)
          })
          .catch(() => {
            setExibirModalProgress(false)
            setOcorreuErro(true)
          })
      } else if (state.situacaoViabilidade == TipoSituacaoEnum.Rascunho) {
        await modificarCasas(entrada)
          .then((respostaApi: { isSuccess: boolean; entity: unknown }) => {
            const resposta = respostaApi.entity as CasasSaida
            goToResultadoViabilidade(resposta)
          })
          .catch(() => {
            setExibirModalProgress(false)
            setOcorreuErro(true)
          })
      }
    }
  }

  return (
    <>
      <ModalProgress visivel={exibirModalProgress} />
      <S.Wrapper>
        <S.Cabecalho>
          <S.Voltar>
            <BackButton titulo="Nova Viabilidade" />
          </S.Voltar>
          <S.Terreno>
            <NomeTerreno nomeTerreno={state?.nomeTerreno} cor="verde" />
          </S.Terreno>
          <S.DataSimulacao data-cy="dataSimulacao">Data da simulação: {new Intl.DateTimeFormat('pt-BR').format(new Date())}</S.DataSimulacao>
          <S.EncolherTudo>
            <FormControlLabel
              value="start"
              control={<Checkbox color="secondary" checked={encolherTudo} onChange={toggleEncolherTudo} />}
              label="Encolher tudo"
              labelPlacement="end"
              data-cy="encolherTudo"
            />
          </S.EncolherTudo>
        </S.Cabecalho>

        <MensagensErro erros={errosValidacao} />

        {ocorreuErro ? (
          <S.WrapperFixed>
            <Erro />
          </S.WrapperFixed>
        ) : carregouMoedaVigente && carregouMoedaCompra && carregouRascunho ? (
          <>
            <Accordion expanded={cards[NomesCartoesViabilidadeEnum.DadosGerais]} data-cy="cardDadosGerais">
              <AccordionSummary onClick={() => toggleCard(NomesCartoesViabilidadeEnum.DadosGerais)} expandIcon={icon}>
                DADOS GERAIS
              </AccordionSummary>
              <AccordionDetails data-cy="conteudoCardDadosGerais">
                <CartaoDadosGerais dadosGerais={informacoesDadosGerais} dadosGeraisHandler={dadosGeraisHandler} />
              </AccordionDetails>
            </Accordion>

            {informacoesDadosGerais.tipoProjeto === TipoProjetoEnum.LoteamentoAberto && (
              <Accordion expanded={cards[NomesCartoesViabilidadeEnum.Loteadora]} data-cy="cardLoteadora">
                <AccordionSummary onClick={() => toggleCard(NomesCartoesViabilidadeEnum.Loteadora)} expandIcon={icon}>
                  LOTEADORA
                </AccordionSummary>
                <AccordionDetails data-cy="conteudoCardLoteadora">
                  <CardLoteadora dadosLoteadora={informacoesDadosLoteadora} dadosLoteadoraHandler={dadosLoteadoraHandler} />
                </AccordionDetails>
              </Accordion>
            )}

            <Accordion expanded={cards[NomesCartoesViabilidadeEnum.DadosCompraTerreno]} data-cy="cardDadosCompraTerreno">
              <AccordionSummary onClick={() => toggleCard(NomesCartoesViabilidadeEnum.DadosCompraTerreno)} expandIcon={icon}>
                DADOS DE COMPRA DO TERRENO
              </AccordionSummary>
              <AccordionDetails data-cy="conteudoCardDadosCompraTerreno">
                <CartaoDadosCompraTerreno
                  tipoProjeto={informacoesDadosGerais.tipoProjeto}
                  modeloNegocio={informacoesDadosGerais.modeloNegocio}
                  dadosCompraTerreno={informacoesDadosCompraTerreno}
                  dadosCompraTerrenoHandler={dadosCompraTerrenoHandler}
                />
              </AccordionDetails>
            </Accordion>

            <Accordion expanded={cards[NomesCartoesViabilidadeEnum.DetalhamentoProjeto]} data-cy="cardDadosDetalhamentoProjeto">
              <AccordionSummary onClick={() => toggleCard(NomesCartoesViabilidadeEnum.DetalhamentoProjeto)} expandIcon={icon}>
                DETALHAMENTO DO PROJETO
              </AccordionSummary>
              <AccordionDetails data-cy="conteudoCardDetalhamentoProjeto">
                <CartaoDadosDetalhamentoProjeto
                  tipoProjeto={informacoesDadosGerais.tipoProjeto}
                  dadosDetalhamentoProjeto={informacoesDadosDetalhamentoProjeto}
                  dadosDetalhamentoProjetoHandler={dadosDetalhamentoProjetoHandler}
                />
              </AccordionDetails>
            </Accordion>

            {(informacoesDadosGerais.tipoProjeto === TipoProjetoEnum.CondominioIncorporacao ||
              informacoesDadosGerais.modeloNegocio === ModeloNegocioEnum.MrvAdquirenteLote) && (
              <Accordion expanded={cards[NomesCartoesViabilidadeEnum.Infraestrutura]} data-cy="cardInfraestrutura">
                <AccordionSummary onClick={() => toggleCard(NomesCartoesViabilidadeEnum.Infraestrutura)} expandIcon={icon}>
                  INFRAESTRUTURA
                </AccordionSummary>
                <AccordionDetails data-cy="conteudoCardInfraestrutura">
                  <CardInfraestrutura dadosInfraestrutura={informacoesDadosInfraestrutura} dadosInfraestruturaHandler={dadosInfraestruturaHandler} />
                </AccordionDetails>
              </Accordion>
            )}
            <Accordion expanded={cards[NomesCartoesViabilidadeEnum.Comercial]} data-cy="cardComercial">
              <AccordionSummary onClick={() => toggleCard(NomesCartoesViabilidadeEnum.Comercial)} expandIcon={icon}>
                COMERCIAL
              </AccordionSummary>
              <AccordionDetails data-cy="conteudoCardComercial">
                <CardComercial dadosComercial={informacoesDadosComercial} dadosComercialHandler={dadosComercialHandler} />
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={cards[NomesCartoesViabilidadeEnum.Construcao]} data-cy="cardConstrucao">
              <AccordionSummary onClick={() => toggleCard(NomesCartoesViabilidadeEnum.Construcao)} expandIcon={icon}>
                CONSTRUÇÃO
              </AccordionSummary>
              <AccordionDetails data-cy="conteudoCardConstrucao">
                <CardConstrucao dadosConstrucao={informacoesDadosConstrucao} dadosConstrucaoHandler={dadosConstrucaoHandler} />
              </AccordionDetails>
            </Accordion>

            <Accordion expanded={cards[NomesCartoesViabilidadeEnum.Urbanizacao]} data-cy="cardUrbanizacao">
              <AccordionSummary onClick={() => toggleCard(NomesCartoesViabilidadeEnum.Urbanizacao)} expandIcon={icon}>
                URBANIZAÇÃO <S.SecaoOpcional>Seção opcional apenas para Loteamento Aberto</S.SecaoOpcional>
              </AccordionSummary>
              <AccordionDetails data-cy="conteudoCardUrbanizacao">
                <CardUrbanizacao
                  tipoProjeto={informacoesDadosGerais.tipoProjeto}
                  dadosUrbanizacao={informacoesDadosUrbanizacao}
                  dadosUrbanizacaoHandler={dadosUrbanizacaoHandler}
                />
              </AccordionDetails>
            </Accordion>

            <S.Rodape>
              <Button variant="outlined" onClick={() => history.goBack()} data-cy="btnCancelar">
                Cancelar
              </Button>
              <Button
                data-cy="btnSimular"
                disabled={validaBotaoSimularHabilitado()}
                variant="contained"
                startIcon={<TrendingUp size={18} />}
                disableElevation={true}
                onClick={() => simular(dadosEntrada)}
              >
                Simular
              </Button>
            </S.Rodape>
          </>
        ) : (
          <S.WrapperFixed>
            <Progress label={processandoDados} />
          </S.WrapperFixed>
        )}
      </S.Wrapper>
    </>
  )
}
